import dayjs from "dayjs";
import React from "react";
import * as Yup from 'yup';
import { TrashIcon } from "./trash";
import _, { isNumber } from "lodash";
import { Container } from './styled';
import { useRouter } from "next/router";
import { LoadingBuffer } from "../utils/Loading";
import { Grid, Pagination } from '@mui/material';
import { yupResolver } from "@hookform/resolvers/yup";
import { DeleteElaborationDialog } from "../../Modal/Delete";
import { Organograma } from "@/utils/organograma/Organograma";
import { useTipeOfFlow } from "@/services/zustand/tipo_fluxo";
import { TextFieldElaboration } from "../../Inputs/TextField";
import { ActionButtonElaborations } from "../../ActionButton";
import { DatePickerElaboration } from "../../Inputs/DatePicker";
import { SelectFieldElaboration } from "../../Inputs/SelectField";
import { CreateUnityElaboration } from "../../Modal/CreateUnidade";
import { ElaborationService } from "@/services/endpoints/elaboracao";
import { useSnackbarElaboration } from "@/hooks/useSnackbarElaboration";
import { SubmitHandler, useFieldArray, useForm } from "react-hook-form";
import { ReutilizarElaborationDialog } from "../Vision/ReutilizarModal";
import { MultipleSelect } from "@/components/global/Inputs/MultipleInput";
import { findingMenuItemKey } from "@/contexts/elaboracao_planos/constants";
import { RelacionamentoJsonService } from "@/services/endpoints/hierarquia";
import { addItemToNodeOrganogram } from "@/utils/organograma/addItemToNode";
import { DisclaimerReuseElaborationDialog } from "../Vision/disclaimerModal";
import { DashboardManagementPlansService } from "@/services/endpoints/dashboard";
import { useElaborationCardItem } from "@/services/zustand/elaboration_card_item";
import { useHierarchyPreparationOfPlans, usePreparationOfPlans } from "@/hooks/elaboracao_planos";
import { analisarTerritorioArray, encontrarCorrespondentes, handleContentRelatedToTerritorySelected, removeDuplicatesFromA } from "../utils";
import { PlansService } from "@/services/endpoints/plans";

const defaultValue = {
  id: '',
  tor: [],
  meta: '',
  setor: '',
  orgao: '',
  territorio: '',
  publicoAlvo: '',
  responsavel: '',
  indicadores: [
    {
      fonte: '',
      indicador: '',
      polaridade: '',
      unidadeMedida: '',
      formulaCalculo: '',
      planejados: [
        {
          prazo: null,
          planejado: '',
        }
      ]
    }
  ]
}

type InputsGoals = {
  meta: any;
}

const SchemaGoals = Yup.object().shape({
  meta: Yup.array().of(
    Yup.object().shape({
      texto: Yup.string().required('Campo obrigatório'),
      orgao: Yup.string().required('Campo obrigatório'),
      setor: Yup.string().required('Campo obrigatório'),
      prazo: Yup.date().nonNullable().required('Campo obrigatório').typeError('Data inválida'),
      territorio: Yup.string(),
      publicoAlvo: Yup.string(),
      responsavel: Yup.string().required('Campo obrigatório'),
      indicadores: Yup.array().of(
        Yup.object().shape({
          fonte: Yup.string().required("Campo obrigatório"),
          indicador: Yup.string().required('Campo obrigatório'),
          polaridade: Yup.string().required('Campo obrigatório'),
          unidadeMedida: Yup.string().required('Campo obrigatório'),
          formulaCalculo: Yup.string().required('Campo obrigatório'),
          planejados: Yup.array().of(
            Yup.object().shape({
              prazo: Yup.date().nonNullable().required('Campo obrigatório').typeError('Data inválida'),
              planejado: Yup.string().required('Campo obrigatório')
            })
          )
        })
      )
    })
  ).required(''),
});

const transformMetaData = (data: any[]) => {
  return data.map((item: any) => {
    const tor = item?.metasTerritorio.map((m: any) => {
      if (m?.bairro) return { id: m?.bairro?.id, descricao: m?.bairro?.name };
      if (m?.regiaoAdministrativa) return { id: m?.regiaoAdministrativa?.id, descricao: m?.regiaoAdministrativa?.name };
      if (m?.areaPlanejamento) return { id: m?.areaPlanejamento?.id, descricao: m?.areaPlanejamento?.name };
      if (m?.regiaoPlanejamento) return { id: m?.regiaoPlanejamento?.id, descricao: m?.regiaoPlanejamento?.name };
      return null;
    }).filter(Boolean);

    const territorio = analisarTerritorioArray(item.metasTerritorio)

    return {
      tor,
      territorio,
      id: item?.id,
      texto: item?.texto || '',
      orgao: item?.orgao?.id || '',
      setor: item?.setor?.id || '',
      publicoAlvo: item?.publicoAlvo || '',
      responsavel: item?.responsavel || '',
      prazo: item.data ? dayjs(item.data) : null,
      indicadores: item?.indicadores?.map((indicador: any) => ({
        id: indicador?.id,
        fonte: indicador?.fonte || '',
        indicador: indicador?.indicador || '',
        polaridade: indicador?.polaridade || '',
        unidadeMedida: indicador?.unidadeMedida || '',
        formulaCalculo: indicador?.formulaCalculo || '',
        planejados: indicador?.values?.map((planejado: any) => ({
          id: planejado?.id,
          prazo: planejado?.data ? dayjs(planejado?.data) : null,
          planejado: planejado?.planejado || ''
        }))
      }))
    };
  });
};

const transformMetaDataReuse = (data: any) => {
  return data?.map((item: any) => {
    const tor = item?.metasTerritorio.map((m: any) => {
      if (m?.bairro) return { id: m?.bairro?.id, descricao: m?.bairro?.name };
      if (m?.regiaoAdministrativa) return { id: m?.regiaoAdministrativa?.id, descricao: m?.regiaoAdministrativa?.name };
      if (m?.areaPlanejamento) return { id: m?.areaPlanejamento?.id, descricao: m?.areaPlanejamento?.name };
      if (m?.regiaoPlanejamento) return { id: m?.regiaoPlanejamento?.id, descricao: m?.regiaoPlanejamento?.name };
      return null;
    }).filter(Boolean);

    const territorio = analisarTerritorioArray(item.metasTerritorio)

    return {
      tor,
      territorio,
      texto: item?.texto || '',
      orgao: item?.orgao?.id || '',
      setor: item?.setor?.id || '',
      publicoAlvo: item?.publicoAlvo || '',
      responsavel: item?.responsavel || '',
      prazo: item.data ? dayjs(item.data) : null,
      indicadores: item?.indicadores?.map((indicador: any) => ({
        id: indicador?.id,
        fonte: indicador?.fonte || '',
        indicador: indicador?.indicador || '',
        polaridade: indicador?.polaridade || '',
        unidadeMedida: indicador?.unidadeMedida || '',
        formulaCalculo: indicador?.formulaCalculo || '',
        planejados: indicador?.values?.map((planejado: any) => ({
          id: planejado?.id,
          prazo: planejado?.data ? dayjs(planejado?.data) : null,
          planejado: planejado?.planejado || ''
        }))
      }))
    };
  });
};

const transformMetaDataReuseV2 = (data: any) => {
  const tor = data?.metasTerritorio.map((m: any) => {
    if (m?.bairro) return { id: m?.bairro?.id, descricao: m?.bairro?.name };
    if (m?.regiaoAdministrativa) return { id: m?.regiaoAdministrativa?.id, descricao: m?.regiaoAdministrativa?.name };
    if (m?.areaPlanejamento) return { id: m?.areaPlanejamento?.id, descricao: m?.areaPlanejamento?.name };
    if (m?.regiaoPlanejamento) return { id: m?.regiaoPlanejamento?.id, descricao: m?.regiaoPlanejamento?.name };
    return null;
  }).filter(Boolean);

  const territorio = analisarTerritorioArray(data.metasTerritorio)

  return {
    tor,
    territorio,
    texto: data?.texto || '',
    orgao: data?.orgao?.id || '',
    setor: data?.setor?.id || '',
    publicoAlvo: data?.publicoAlvo || '',
    responsavel: data?.responsavel || '',
    prazo: data.data ? dayjs(data.data) : null,
    indicadores: data?.indicadores?.map((indicador: any) => ({
      id: indicador?.id,
      fonte: indicador?.fonte || '',
      indicador: indicador?.indicador || '',
      polaridade: indicador?.polaridade || '',
      unidadeMedida: indicador?.unidadeMedida || '',
      formulaCalculo: indicador?.formulaCalculo || '',
      planejados: indicador?.values?.map((planejado: any) => ({
        id: planejado?.id,
        prazo: planejado?.data ? dayjs(planejado?.data) : null,
        planejado: planejado?.planejado || ''
      }))
    }))
  };
};

export const GoalsForm: React.FC = () => {
  const {
    trigger,
    clearErrors,
    watch: watchGoals,
    control: controlGoals,
    register: registerGoals,
    setValue: setValueGoals,
    handleSubmit: handleSubmitGoals,
    formState: { errors: errosGoals }
  } = useForm<InputsGoals>({
    resolver: yupResolver(SchemaGoals),
    defaultValues: { meta: [defaultValue] }
  });

  const { append: appendGoals, update: updateGoals, remove: removeGoals } = useFieldArray({
    control: controlGoals,
    name: "meta"
  });

  const fields = watchGoals('meta');

  const {
    GetUnidadesMedida,
    GoalsElaborations,
    NumberElaboration,
    PostUnidadesMedida,
    IndicatorsElaboration,
    DeleteGoasElaborations,
    UpdateGoalsElaborations,
    GetObjectivesElaboration,
    UpdateNumbersElaboration,
    DeleteNumbersElaboration,
    DeleteIndicatorElaboration,
    GetThematicAxisElaboration,
    GetObjectivesEixoElaboration,
  } = React.useMemo(() => new ElaborationService(), []);

  const router = useRouter();
  const pathname = router.pathname;

  const {
    itemsMenu,
    completCode,
    setNavigable,
    selectedItemsMenu,
    setDefaultItemMenuId,
    handleFetchProgressCodePlanId,
  } = usePreparationOfPlans();

  const routerId = router.query.id;
  const [page, setPage] = React.useState(1);
  const [data, setData] = React.useState<any[]>([]);
  const { tipo: tipoFluxo, planId } = useTipeOfFlow();
  const [filterData, setFilterData] = React.useState({
    setor: [] as any[],
    orgaoResponsavel: [] as any[],
    territorio: {} as Record<string, any>
  });
  const [loading, setLoading] = React.useState(false);
  const [openUnity, setOpenUnity] = React.useState(false);
  const [reutilizar, setReutilizar] = React.useState(false);
  const [deleteGoalId, setDeleteGoalId] = React.useState(0);
  const [deleteLinhaId, setDeleteLinhaId] = React.useState(0);
  const [objetivos, setObjetivos] = React.useState<any[]>([]);
  const [goalSelectedIndex, setGoalIndex] = React.useState(0);
  const [preview, setPreview] = React.useState<boolean>(false);
  const [disabeSubmit, setDisableSubmit] = React.useState(false);
  const [deleteGoalIndex, setDeleteGoalIndex] = React.useState(0);
  const { getAllFilters } = React.useMemo(() => new DashboardManagementPlansService(), []);
  const [deleteLinhaIndex, setDeleteLinhaIndex] = React.useState(0);
  const [openDisclaimer, setOpenDisclaimer] = React.useState(false);
  const [currentIndexEixo, setCurrentIndexEixo] = React.useState(0);
  const [deleteIndicatorId, setDeleteIndicatorId] = React.useState(0);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [unidadesMedida, setUnidadesMedida] = React.useState<any[]>([]);
  const [openDeleteModal3, setOpenDeleteModal3] = React.useState(false);
  const [eixos_tematicos, setEixosTematicos] = React.useState<any[]>([]);
  const [indicadoresSelected, setIndicadores] = React.useState({} as any);
  const [deleteIndicatorIndex, setDeleteIndicatorIndex] = React.useState(0);
  const [openDeleteLinhaModal, setOpenDeleteLinhaModal] = React.useState(false);
  const { toggleErrorSnackbar, toggleSuccessSnackbar } = useSnackbarElaboration();
  const zustandSelectedCardItem = useElaborationCardItem(state => state.cardItem);

  const total = objetivos.length;

  function getMessageErrorByNameRef(json: any, title: any) {
    try {
      const foundObject = json?.meta?.filter((item: any) => Boolean(item))?.find((item: any) => item[title]);
      return foundObject ? foundObject[title].message : null;
    } catch (error) {
      return null
    }
  }

  function getMessageErrorByNameRefSubArray(json: any, title: any, index: any) {
    try {
      const foundObject = json?.meta?.map((item: any) => {
        return item.indicadores.find((subItem: any) => subItem[title]);
      })

      return foundObject && foundObject[index] ? foundObject[index][title].message : null;
    } catch (error) {
      return null
    }
  }

  function getMessageErrorByNameRefSubArrayPlanned(json: any, title: any, index: any) {
    if (Object.keys(json).length == 0) return null;

    const planejadosArray = json.meta.flatMap((item: any) =>
      item?.indicadores?.flatMap((indicador: any) => indicador.planejados)
    );

    return planejadosArray && planejadosArray[index] && planejadosArray[index][title] ? planejadosArray[index][title].message : null;
  }

  const handleLeftClick = async () => {
    handleChange("", 1)
    const isValid = await trigger();

    if (isValid) {
      handleSubmitGoals(onSubmit)({
        data: fields,
        nativeEvent: { submitter: { name: 'any' } }
      } as any);
    }
    setCurrentIndexEixo(currentIndexEixo === 0 ? eixos_tematicos.length - 1 : currentIndexEixo - 1);
  };

  const handleRightClick = async () => {
    handleChange("", 1)
    const isValid = await trigger();

    if (isValid) {
      handleSubmitGoals(onSubmit)({
        data: fields,
        nativeEvent: { submitter: { name: 'any' } }
      } as any);
    }
    setCurrentIndexEixo(currentIndexEixo === eixos_tematicos.length - 1 ? 0 : currentIndexEixo + 1);
  };

  const handleChange = async (_: any, value: any) => {
    if (typeof _ == 'string') {
      setPage(value);
      return;
    }

    const isValid = await trigger();

    if (isValid) {
      handleSubmitGoals(onSubmit)({
        data: fields,
        nativeEvent: { submitter: { name: 'any' } }
      } as any);

    }
    setPage(value);
  };

  const handleSaveUnity = (e: any) => {
    PostUnidadesMedida({ descricao: e }).then(res => {
      GetUnidadesMedida().then(res => {
        const { data } = res.data as any;
        setUnidadesMedida(data.map((item: any) => ({ value: item.unidade, name: item.unidade })));
        setOpenUnity(false);
      })
    })
  };

  const filterSectors = (data: any, orgao: any) => {
    const findItem = data?.orgaoResponsavel?.find((item: any) => item?.id == orgao);
    const filterItems =
      data?.setor?.filter((item: any) => item.codUa == findItem?.codUa)
        .map((item: any) => ({ value: item?.id, name: item?.descricao }))

    return filterItems
  };

  React.useEffect(() => {
    if (!routerId) return;
    if (!(pathname.split('/').includes("elaboracao_planos") || pathname.split('/').includes("aprovacao_planos"))) return;
    if (routerId && pathname.split('/').includes("elaboracao_planos") || pathname.split('/').includes("aprovacao_planos")) {
      GetThematicAxisElaboration(routerId).then(res => {
        setEixosTematicos(res.data);
      });
    }
  }, [GetThematicAxisElaboration, pathname, routerId]);

  React.useEffect(() => {
    if (!routerId) return;
    if (eixos_tematicos.length === 0) return;
    if (!(pathname.split('/').includes("elaboracao_planos") || pathname.split('/').includes("aprovacao_planos"))) return;

    setLoading(true);
    GetObjectivesEixoElaboration(routerId, eixos_tematicos[currentIndexEixo].id).then((res: any) => {
      setObjetivos(res.data);
    }).finally(() => setLoading(false));
  }, [GetObjectivesEixoElaboration, currentIndexEixo, eixos_tematicos, pathname, routerId]);

  React.useEffect(() => {
    const objetivo = objetivos[page - 1];
    clearErrors();
    if (objetivo?.metas?.length > 0) {
      setValueGoals('meta', transformMetaData(objetivo.metas))
    } else {
      setValueGoals('meta', [defaultValue])
    }
  }, [clearErrors, objetivos, page, setValueGoals]);

  React.useEffect(() => {
    if (pathname.split('/').includes('elaboracao_planos') || pathname.split('/').includes('aprovacao_planos'))
      getAllFilters().then((res: any) => {
        const { data } = res.data as any;
        setFilterData(data);
      })
  }, [getAllFilters, pathname]);

  const { GetPlano } = React.useMemo(() => new PlansService(), []);
  const fetchPlanData = React.useCallback(async (planId: string) => {
    try {
      const objectivesResponse = await GetObjectivesElaboration(planId);
      const data = objectivesResponse.data as any[];

      const planoResponse = await GetPlano(planId);
      const planoData = planoResponse.data.data;

      if (planoData.createdByPlanejator === false) {
        setData(planoData.metas);
      } else {
        if (data.some((item: any) => item.metas.length > 0)) {
          setData(data);
        } else {
          setData([]);
        }
      }
    } catch (error) {
      console.error("Error fetching plan data:", error);
    }
  }, [GetObjectivesElaboration, GetPlano])


  React.useEffect(() => {
    if (planId && tipoFluxo == 'substituir' && (pathname.split('/').includes("elaboracao_planos") || pathname.split('/').includes("aprovacao_planos"))) {
      fetchPlanData(planId)
    }
  }, [fetchPlanData, pathname, planId, tipoFluxo]);

  React.useEffect(() => {
    if (!router.isReady) return

    setPreview(router.asPath.includes('preview'));
  }, [router.asPath, router.isReady]);

  React.useEffect(() => {
    GetUnidadesMedida().then(res => {
      const { data } = res.data as any;
      setUnidadesMedida(data.map((item: any) => ({ value: item.unidade, name: item.unidade })));
    })
  }, [GetUnidadesMedida]);

  const { consultarOrganograma, salvarOrganograma, startOrganograma } = new Organograma(router.query.id as unknown as number);

  const { insertItemById, updateItemById, checkLayerExists, deleteItemById } = useHierarchyPreparationOfPlans();
  const { startRelacionamento, consultarRelacionamento, atualizarRelacionamento } = new RelacionamentoJsonService(router.query.id as unknown as number);

  const onSubmit: SubmitHandler<any> = async (data, event: any) => {
    const { meta } = data;
    const objetivoId = objetivos[page - 1]?.id;
    const metaCode = completCode.find(item => item.code == 'metas')

    if (disabeSubmit) return;

    setDisableSubmit(true);

    let submittedData = meta;

    if (event?.data?.length > 0) {
      submittedData = event.data;
    }

    try {
      for (const [indexMeta, itemMeta] of submittedData.entries()) {
        for (const [indexIndicador, itemIndicador] of itemMeta.indicadores.entries()) {
          const { planejados, unidadeMedida: uni, id, ...rest } = itemIndicador;

          const indicador = isNumber(id)
            ? {
              ...rest,
              id,
              planoId: router.query.id,
              unidadeMedida: unidadesMedida.find(item => item.value === uni)?.name
            }
            : {
              ...rest,
              planoId: router.query.id,
              unidadeMedida: unidadesMedida.find(item => item.value === uni)?.name
            };

          try {
            const res = await IndicatorsElaboration(indicador);
            const data = res.data;

            setValueGoals(`meta.${indexMeta}.indicadores.${indexIndicador}.id`, data.id);

            itemIndicador.id = data.id;
          } catch (error) {
            console.error('Erro ao elaborar indicador:', error);
            setDisableSubmit(false);

          }
        }
      }

      for (const [indexMeta, itemMeta] of fields.entries()) {
        const { indicadores, tor, ...rest } = itemMeta;

        const meta = {
          ...rest,
          objetivoId,
          planoId: router.query.id,
          eixo_tematico: eixos_tematicos[currentIndexEixo]?.id,
          indicadoresIds: indicadores.map((item: any) => item.id), // IDs agora estão garantidos
          prazo: dayjs(itemMeta.prazo).format('YYYY-MM-DD') + 'T00:00:00',
          territorio: encontrarCorrespondentes(tor, filterData.territorio),
        };

        try {
          if (itemMeta.id) {
            await UpdateGoalsElaborations(meta, itemMeta.id);
          } else {
            const postResponse = await GoalsElaborations(meta);

            let count = 0;
            for (const item of [postResponse.data.data]) {
              count += 1;
              if (!fields.some((item: any) => typeof item.id == 'number') && count == 1) {
                try {
                  const relacionamento = await consultarRelacionamento();
                  const root = JSON.parse(JSON.parse(relacionamento));
                  const newInsertItem = updateItemById({
                    root,
                    targetId: objetivoId,
                    item: { metas: { itens: [] } },
                    layerName: 'objetivos',
                  });

                  startRelacionamento(JSON.stringify(newInsertItem));
                  await atualizarRelacionamento(); // Aguarda o término da atualização

                  const relacionamentov2 = await consultarRelacionamento();
                  const rootv2 = JSON.parse(JSON.parse(relacionamentov2));

                  const newInsertItemv2 = insertItemById({
                    root: rootv2,
                    targetId: objetivoId,
                    item: { id: postResponse?.data?.data, relacionamento: {} },
                    layerName: 'metas',
                  });

                  startRelacionamento(JSON.stringify(newInsertItemv2));
                  await atualizarRelacionamento(); // Aguarda o término da atualização
                  setValueGoals(`meta.${indexMeta}.id`, postResponse.data.data);

                } catch (error) {
                  console.error(
                    `Erro ao atualizar a camada de objetivos para o item ${objetivoId}:`,
                    error
                  );
                }
              } else {
                const relacionamento = await consultarRelacionamento();
                const root = JSON.parse(JSON.parse(relacionamento));

                const newInsertItem = insertItemById({
                  root,
                  targetId: objetivoId,
                  item: { id: postResponse?.data?.data, relacionamento: {} },
                  layerName: 'metas',
                });

                startRelacionamento(JSON.stringify(newInsertItem));
                await atualizarRelacionamento(); // Aguarda o término da atualização
              }

            }
          }
        } catch (error) {
          console.error('Erro ao processar metas:', error);
          setDisableSubmit(false);
        }

        for (const [indexIndicador, indicadorItem] of indicadores.entries()) {
          for (const [indexPlanejado, planejadoItem] of indicadorItem.planejados.entries()) {
            const planejado = {
              planoId: Number(router.query.id),
              planejado: Number(planejadoItem.planejado),
              indicadorId: indicadorItem.id, // O ID está garantido aqui
              date: dayjs(planejadoItem.prazo).format('YYYY-MM-DD') + 'T00:00:00',
            };

            try {
              if (planejadoItem.id) {
                await UpdateNumbersElaboration(planejadoItem.id, planejado);
              } else {
                await NumberElaboration(planejado);
              }
            } catch (error) {
              setDisableSubmit(false);
              console.error('Erro ao processar planejado:', error);
            }
          }
        }
      };

      toggleSuccessSnackbar();
      setTimeout(() => toggleSuccessSnackbar(), 3000)
    } catch {
      toggleErrorSnackbar();
    } finally {
      if (event.nativeEvent.submitter.name == 'next_step') {
        setNavigable(true)

        if (router.pathname.includes('epl')) {
          router.push('dashboard/aprovacao_planos/' + router.query.id + '/epl/preview')
        } else {
          router.push('/dashboard/elaboracao_planos/' + router.query.id);
        }

        const plan = itemsMenu[findingMenuItemKey(zustandSelectedCardItem)] as Record<string, any>;
        const planId = plan[selectedItemsMenu?.layer as string]
          .find((item: any) => item.id == selectedItemsMenu?.id).id + 1;
        setDefaultItemMenuId(planId);
      } else {
        setNavigable(false)
        const plan = itemsMenu[findingMenuItemKey(zustandSelectedCardItem)] as Record<string, any>;
        const planId = plan[selectedItemsMenu?.layer as string]
          .find((item: any) => item.id == selectedItemsMenu?.id).id;
        setDefaultItemMenuId(planId);

        if (router.pathname.includes('epl')) {
          router.push('dashboard/aprovacao_planos/' + router.query.id + '/epl/preview')
        } else {
          router.push('/dashboard/elaboracao_planos/' + router.query.id);
        }
        handleFetchProgressCodePlanId(router.query.id)
      }

      setDisableSubmit(false);
    }

    if (metaCode != undefined) return;

    try {
      const response = await consultarOrganograma();
      const organograma = response.Organograma;

      const newItem = {
        "tooltip": "",
        "position": "",
        "name": "Meta",
        "subordinates": [],
        "manager": 'Objetivo',
      };

      const newOrganograma = addItemToNodeOrganogram(organograma, 'Objetivo', newItem);

      startOrganograma(newOrganograma);
      salvarOrganograma();
    } catch {
      // toggleErrorSnackbar('Organograma', 'Erro ao salvar o organograma.');

    }
  }

  const ThematicAxisBanner = () => {
    return (
      <React.Fragment>
        <Grid item xs={12} className="goals_select_content_wrapper">
          <p>Eixo temático</p>
        </Grid>
        <Grid item xs={12}>
          <div className="goals_select_wrapper">
            <div className="goals_left_arrow" onClick={() => handleLeftClick()}>{"<"}</div>
            <div className="goals_select_content_wrapper">
              <p>{eixos_tematicos[currentIndexEixo]?.texto}</p>
              <span>Eixo temático {currentIndexEixo + 1} de {eixos_tematicos.length}</span>
            </div>
            <div className="goals_rigth_arrow" onClick={() => handleRightClick()}>{">"}</div>
          </div>
        </Grid>
        {eixos_tematicos[currentIndexEixo]?.obejtivos?.length == 0 ? null : (
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <div className="pagination_wrapper">
              <Pagination
                count={total}
                page={page}
                onChange={handleChange}
                hidePrevButton hideNextButton
                variant="outlined" shape="rounded"
              />
              <p>Página {page} de {total}</p>
            </div>
          </Grid>
        )
        }
        <Grid item xs={12}>
          {eixos_tematicos[currentIndexEixo]?.obejtivos?.length == 0 ? null : (
            <div className="strategy_wrapper">
              <p>
                <b>Objetivo:</b>&nbsp;
                {objetivos[page - 1]?.texto}
              </p>
            </div>
          )}
        </Grid>
      </React.Fragment >
    );
  }

  interface ErrorMessageProps {
    errors: any;
    name: string;
    index: number; // Adicione o índice para garantir que está validando o erro correto
  }

  const ErrorMessage: React.FC<ErrorMessageProps> = ({ errors, name, index }) => {
    const error = errors?.meta?.[index]?.[name];
    return error ? <div className="error_wrapper">
      <span>{error.message}</span>
    </div> : null;
  };

  interface ErrorMessagePropsIndicator {
    errors: any;
    name: string; // Nome do campo para validar
    metaIndex: number; // Índice do item em "meta"
    indicadorIndex: number; // Índice do item em "indicadores"
  }

  const ErrorMessageIndicator: React.FC<ErrorMessagePropsIndicator> = ({ errors, name, metaIndex, indicadorIndex }) => {
    // Acessa o erro específico
    const error = errors?.meta?.[metaIndex]?.indicadores?.[indicadorIndex]?.[name];
    return error ? <div className="error_wrapper" style={{ marginTop: '' }}>
      <span>{error.message}</span>
    </div> : null;
  };

  interface ErrorMessagePropsPlanned {
    errors: any;
    name: string; // Nome do campo para validar
    metaIndex: number; // Índice do item em "meta"
    indicadorIndex: number; // Índice do item em "indicadores"
    plannedIndex: number
  }


  const ErrorMessagePlanned: React.FC<ErrorMessagePropsPlanned> = ({ errors, name, metaIndex, indicadorIndex, plannedIndex }) => {
    // Acessa o erro específico
    const error = errors?.meta?.[metaIndex]?.indicadores?.[indicadorIndex]?.planejados?.[plannedIndex]?.[name];
    return error ? <div className="error_wrapper" style={{ marginTop: name != 'planejado' ? '-.7rem' : '' }}>
      <span>{error.message}</span>
    </div> : null;
  };



  const Fields = () => {
    if (eixos_tematicos && eixos_tematicos[currentIndexEixo] && eixos_tematicos[currentIndexEixo].obejtivos.length == 0) return null;

    return (
      <>
        <Grid item xs={12} sx={{ ml: 2 }}>
          {fields?.map((field: any, goalIndex: any) => {
            const tor = watchGoals(`meta.${goalIndex}.tor`);
            const orgao = watchGoals(`meta.${goalIndex}.orgao`);
            const setor = watchGoals(`meta.${goalIndex}.setor`);
            const texto = watchGoals(`meta.${goalIndex}.texto`);
            const prazo = watchGoals(`meta.${goalIndex}.prazo`);
            const territorio = watchGoals(`meta.${goalIndex}.territorio`);
            const responsavel = watchGoals(`meta.${goalIndex}.responsavel`);

            return (
              <React.Fragment key={field?.id || `${goalIndex}-${texto}`}>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 2,
                    borderRadius: '5px',
                    padding: '0 1rem  0 0',
                    background: '#DFDFDF',
                  }}
                >
                  <Grid item xs={12}>
                    <input
                      type="hidden"
                      defaultValue={field?.id}
                      {...registerGoals(`meta.${goalIndex}.id`, { value: field?.id })}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <DatePickerElaboration
                      width="90%"
                      label="Prazo"
                      formName="Meta"
                      required={true}
                      errors={errosGoals}
                      defaultValue={prazo}
                      commentTittle={texto}
                      control={controlGoals as any}
                      name={`meta.${goalIndex}.prazo`}
                    />
                    <ErrorMessage errors={errosGoals} name="prazo" index={goalIndex} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextFieldElaboration
                      rows={3}
                      label="Meta"
                      multiline={true}
                      required={true}
                      errors={errosGoals}
                      formName="Meta"
                      defaultValue={texto}
                      commentTittle={texto}
                      register={registerGoals}
                      placeholder="Digite a meta"
                      name={`meta.${goalIndex}.texto`}
                    />
                    <ErrorMessage errors={errosGoals} name="texto" index={goalIndex} />
                  </Grid>
                  <Grid item xs={12}>
                    <SelectFieldElaboration
                      required={false}
                      label="Território"
                      formName="Meta"
                      errors={errosGoals}
                      commentTittle={texto}
                      register={registerGoals}
                      defaultValue={territorio}
                      placeholder="Selecione o território"
                      data={[
                        { value: 0, name: '-' },
                        { value: 1, name: 'AP' },
                        { value: 2, name: 'RP' },
                        { value: 3, name: 'RA' },
                        { value: 4, name: 'Bairros' }
                      ]}
                      name={`meta.${goalIndex}.territorio`}
                      onClick={() => updateGoals(goalIndex, { ...field, tor: [] })}
                      setValue={(value: any) => setValueGoals(`meta.${goalIndex}.territorio`, value)}
                    />
                    <div className="error_wrapper">
                      <span>{getMessageErrorByNameRef(errosGoals, 'territorio')}</span>
                    </div>
                  </Grid>
                  {territorio != 0 && (
                    <Grid item xs={12}>
                      <MultipleSelect
                        fullWidth={true}
                        value={Array.isArray(tor) ? tor : []}
                        setValue={(e) => {
                          const items = removeDuplicatesFromA(tor, e)
                          updateGoals(goalIndex, { ...field, tor: items })
                        }}
                        {...registerGoals(`meta.${goalIndex}.tor`, { required: false })}
                        data={handleContentRelatedToTerritorySelected(filterData, territorio, tor)}
                      />
                    </Grid>
                  )}
                  <Grid item xs={3}>
                    <TextFieldElaboration
                      required={false}
                      errors={errosGoals}
                      label="Público-alvo"
                      formName="Meta"
                      register={registerGoals}
                      commentTittle={texto}
                      placeholder="Digite o público-alvo"
                      name={`meta.${goalIndex}.publicoAlvo`}
                    />
                    <div className="error_wrapper" style={{ marginTop: '1rem' }}>
                      <span>{getMessageErrorByNameRef(errosGoals, 'publicoAlvo')}</span>
                    </div>
                  </Grid>
                  <Grid item xs={3}>
                    <SelectFieldElaboration
                      label="Órgão"
                      required={true}
                      formName="Meta"
                      errors={errosGoals}
                      defaultValue={orgao}
                      commentTittle={texto}
                      placeholder="Selecione"
                      register={registerGoals}
                      name={`meta.${goalIndex}.orgao`}
                      setValue={(value) => setValueGoals(`meta.${goalIndex}.orgao`, value)}
                      data={filterData.orgaoResponsavel.map((item) => ({ value: item.id, name: item.sigla }))}
                    />
                    <ErrorMessage errors={errosGoals} name="orgao" index={goalIndex} />
                  </Grid>
                  <Grid item xs={3}>
                    <SelectFieldElaboration
                      label="Setor"
                      required={true}
                      errors={errosGoals}
                      defaultValue={setor}
                      formName="Meta"
                      commentTittle={texto}
                      placeholder="Selecione"
                      register={registerGoals}
                      name={`meta.${goalIndex}.setor`}
                      data={filterSectors(filterData, orgao)}
                      setValue={(value) => setValueGoals(`meta.${goalIndex}.setor`, value)}
                    />
                    <ErrorMessage errors={errosGoals} name="setor" index={goalIndex} />
                  </Grid>
                  <Grid item xs={3} sx={{ mt: -.3 }}>
                    <TextFieldElaboration
                      required={true}
                      errors={errosGoals}
                      label="Responsável"
                      commentTittle={texto}
                      formName="Meta"
                      register={registerGoals}
                      defaultValue={responsavel}
                      placeholder="Nome do responsável"
                      name={`meta.${goalIndex}.responsavel`}
                    />
                    <ErrorMessage errors={errosGoals} name="responsavel" index={goalIndex} />
                  </Grid>
                  <Grid item xs={12} sx={{ mb: 2 }}>
                    <p className="sub_item_topographic">
                      Indicadores
                    </p>
                  </Grid>
                  {field?.indicadores?.map((indicator: any, indicatorIndex: any, arr: any[]) => {
                    const randomIdIndicadores = Math.random();
                    const lastIdesOfIndicator = arr?.lastIndexOf(arr[arr.length - 1]);
                    const fonte = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.fonte`);
                    const indicador = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.indicador`);
                    const unidade = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.unidadeMedida`);
                    const polaridade = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.polaridade`);
                    const formula = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.formulaCalculo`);

                    return (
                      <React.Fragment key={field?.id || `${indicatorIndex}-${indicador}`}>
                        <Grid
                          container
                          spacing={2}
                          className="sub_container"
                          sx={{ background: '#fff', margin: '0 0 1rem 1rem', padding: '0 1rem 1rem 1rem ' }}
                        >
                          <Grid item xs={12} sx={{ mt: 2 }}>
                            <TextFieldElaboration
                              required={true}
                              label="Indicador"
                              errors={errosGoals}
                              commentTittle={texto}
                              formName="Meta"
                              register={registerGoals}
                              defaultValue={indicador}
                              placeholder="Digite o indicador"
                              name={`meta.${goalIndex}.indicadores.${indicatorIndex}.indicador`}
                            />
                            <ErrorMessageIndicator
                              errors={errosGoals}
                              name="indicador"
                              metaIndex={goalIndex}
                              indicadorIndex={indicatorIndex}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <SelectFieldElaboration
                              required={true}
                              errors={errosGoals}
                              commentTittle={texto}
                              formName="Meta"
                              data={unidadesMedida}
                              defaultValue={unidade}
                              register={registerGoals}
                              label="Unidade de medida"
                              handleCreate={() => setOpenUnity(true)}
                              placeholder="Crie uma nova unidade de medida"
                              name={`meta.${goalIndex}.indicadores.${indicatorIndex}.unidadeMedida`}
                              setValue={(value) => setValueGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.unidadeMedida`, value)}
                            />
                            <ErrorMessageIndicator
                              errors={errosGoals}
                              name="unidadeMedida"
                              metaIndex={goalIndex}
                              indicadorIndex={indicatorIndex}
                            />
                          </Grid>
                          <Grid item xs={3}>
                            <TextFieldElaboration
                              required={true}
                              errors={errosGoals}
                              formName="Meta"
                              placeholder="Digite"
                              commentTittle={texto}
                              defaultValue={formula}
                              register={registerGoals}
                              label="Fórmula de cálculo"
                              name={`meta.${goalIndex}.indicadores.${indicatorIndex}.formulaCalculo`}
                            />
                            <ErrorMessageIndicator
                              errors={errosGoals}
                              name="formulaCalculo"
                              metaIndex={goalIndex}
                              indicadorIndex={indicatorIndex}
                            />
                          </Grid>
                          <Grid item xs={3} sx={{ mt: 0 }}>
                            <TextFieldElaboration
                              label="Fonte"
                              required={true}
                              errors={errosGoals}
                              formName="Meta"
                              placeholder="Digite"
                              defaultValue={fonte}
                              commentTittle={texto}
                              register={registerGoals}
                              name={`meta.${goalIndex}.indicadores.${indicatorIndex}.fonte`}
                            />
                            <ErrorMessageIndicator
                              errors={errosGoals}
                              name="fonte"
                              metaIndex={goalIndex}
                              indicadorIndex={indicatorIndex}
                            />
                          </Grid>
                          <Grid item xs={3} sx={{ mt: 0 }}>
                            <SelectFieldElaboration
                              required={true}
                              label="Polaridade"
                              errors={errosGoals}
                              formName="Meta"
                              commentTittle={texto}
                              placeholder="Selecione"
                              register={registerGoals}
                              defaultValue={polaridade}
                              name={`meta.${goalIndex}.indicadores.${indicatorIndex}.polaridade`}
                              setValue={(value) => setValueGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.polaridade`, value)}
                              data={[{ value: 'Negativo', name: 'Negativo' }, { value: 'Positivo', name: 'Positivo' }, { value: 'Neutro', name: 'Neutro' }]}
                            />
                            <ErrorMessageIndicator
                              errors={errosGoals}
                              name="polaridade"
                              metaIndex={goalIndex}
                              indicadorIndex={indicatorIndex}
                            />
                          </Grid>
                          {indicator?.planejados?.map((plannedField: any, plannedIndex: any, array: any) => {
                            const randomIdPlanejados = Math.random();
                            const lastIdesOfPlanned = array?.lastIndexOf(array[array.length - 1]);
                            const id = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.id`)
                            const prazo = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.prazo`);
                            const planejado = watchGoals(`meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.planejado`);

                            return (
                              <React.Fragment key={plannedField?.id || `${plannedIndex}-${id}`}>
                                <Grid item xs={12}>
                                  <input
                                    type="hidden"
                                    {
                                    ...registerGoals(
                                      `meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.id`,
                                      { value: id })}
                                    defaultValue={id}
                                  />
                                </Grid>
                                <Grid item xs={3}>
                                  <DatePickerElaboration
                                    width="90%"
                                    label="Prazo"
                                    required={true}
                                    commentTittle={texto}
                                    errors={errosGoals}
                                    formName="Meta"
                                    defaultValue={prazo}
                                    control={controlGoals as any}
                                    name={`meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.prazo`}
                                  />
                                  <ErrorMessagePlanned
                                    errors={errosGoals}
                                    name="prazo"
                                    plannedIndex={plannedIndex}
                                    metaIndex={goalIndex}
                                    indicadorIndex={indicatorIndex}
                                  />
                                </Grid>
                                <Grid item xs={9}>
                                  <TextFieldElaboration
                                    type='number'
                                    required={true}
                                    formName="Meta"
                                    label="Planejado"
                                    commentTittle={texto}
                                    errors={errosGoals}
                                    defaultValue={planejado}
                                    register={registerGoals}
                                    placeholder="Digite o valor do planejado para o indicador da meta"
                                    name={`meta.${goalIndex}.indicadores.${indicatorIndex}.planejados.${plannedIndex}.planejado`}
                                  />
                                  <ErrorMessagePlanned
                                    errors={errosGoals}
                                    name="planejado"
                                    plannedIndex={plannedIndex}
                                    metaIndex={goalIndex}
                                    indicadorIndex={indicatorIndex}
                                  />
                                </Grid>
                                <Grid item xs={12} sx={{ mb: 2, display: 'flex', justifyContent: lastIdesOfPlanned == plannedIndex ? 'space-between' : 'flex-end' }}>
                                  {lastIdesOfPlanned == plannedIndex && (
                                    <div className="add_line_wrapper">
                                      <p onClick={() => {
                                        const newPlanejados = [
                                          ...indicator.planejados,
                                          { prazo: null, planejado: '' },
                                        ];
                                        updateGoals(goalIndex, {
                                          ...field,
                                          indicadores: field.indicadores.map((ind: any, i: number) => i === indicatorIndex ? { ...ind, planejados: newPlanejados } : ind)
                                        });
                                      }}>
                                        {`+ Adicionar linha`}
                                      </p>
                                    </div>
                                  )}
                                  {plannedIndex != 0 && (
                                    <div
                                      className="remove_line_wrapper"
                                      onClick={() => {
                                        setOpenDeleteLinhaModal(true);
                                        setDeleteLinhaIndex(plannedIndex)
                                        setDeleteLinhaId(plannedField?.id)
                                        setGoalIndex(goalIndex)
                                        setIndicadores(indicator)
                                      }}
                                    >
                                      <TrashIcon />
                                      <p>Excluir</p>
                                    </div>
                                  )}
                                </Grid>
                                <DeleteElaborationDialog open={openDeleteLinhaModal} setOpen={(e) => setOpenDeleteLinhaModal(e)} onDelete={() => {
                                  const newPlanejados = indicadoresSelected.planejados.filter((_: any, i: any) => i != goalSelectedIndex);

                                  updateGoals(goalSelectedIndex, {
                                    ...field,
                                    indicadores: field.indicadores.map((ind: any, i: number) => i === indicatorIndex ? { ...ind, planejados: newPlanejados } : ind)
                                  });

                                  if (deleteLinhaId != 0) {
                                    DeleteNumbersElaboration(deleteLinhaId);
                                    setDeleteLinhaId(0)
                                  }

                                  setOpenDeleteLinhaModal(false);
                                }} />
                              </React.Fragment>
                            )
                          })}
                        </Grid>
                        <Grid item xs={12} sx={{ mb: 2, mt: -2, display: 'flex', justifyContent: lastIdesOfIndicator == indicatorIndex ? 'space-between' : 'flex-end' }}>
                          {lastIdesOfIndicator == indicatorIndex && (
                            <div className="add_line_wrapper">
                              <p onClick={() => {
                                const newIndicadores = [
                                  ...field.indicadores,
                                  {
                                    fonte: '',
                                    indicador: '',
                                    polaridade: '',
                                    unidadeMedida: '',
                                    formula_calculo: '',
                                    planejados: [
                                      {
                                        prazo: null,
                                        planejado: '',
                                      }
                                    ]
                                  }
                                ];
                                updateGoals(goalIndex, { ...field, indicadores: newIndicadores });
                              }}>
                                {`+ Adicionar indicador para meta`}
                              </p>
                            </div>

                          )}
                          {indicatorIndex != 0 && !preview && (
                            <div
                              className="remove_line_wrapper"
                              onClick={() => {
                                setOpenDeleteModal(true)
                                setDeleteIndicatorIndex(indicatorIndex)
                                setDeleteIndicatorId(field.indicadores[indicatorIndex]?.id)
                              }}
                            >
                              <TrashIcon />
                              <p>Excluir</p>
                            </div>
                          )}
                        </Grid>
                        <DeleteElaborationDialog open={openDeleteModal} setOpen={(e) => setOpenDeleteModal(e)} onDelete={() => {
                          const newIndicadores = field.indicadores.filter((_: any, i: any) => i !== deleteIndicatorIndex);
                          updateGoals(goalIndex, { ...field, indicadores: newIndicadores });

                          if (deleteIndicatorId != 0) {
                            DeleteIndicatorElaboration(deleteIndicatorId);
                            setDeleteIndicatorId(0)
                          }

                          setOpenDeleteModal(false);
                        }} />
                      </React.Fragment>
                    )
                  })}
                  {goalIndex != 0 && (
                    <Grid item xs={12} sx={{ mb: 1 }} display='flex' justifyContent='flex-end'>
                      <div
                        className="remove_line_wrapper"
                        onClick={() => {
                          setOpenDeleteModal3(true);
                          setDeleteGoalId(field.id)
                          setDeleteGoalIndex(goalIndex)
                        }}
                      >
                        <TrashIcon />
                        <p>Excluir</p>
                      </div>
                    </Grid>
                  )}
                  <DeleteElaborationDialog open={openDeleteModal3} setOpen={(e) => setOpenDeleteModal3(e)} onDelete={async () => {
                    removeGoals(deleteGoalIndex);

                    if (deleteGoalId != 0) {
                      const relacionamento = await consultarRelacionamento();
                      const root = JSON.parse(JSON.parse(relacionamento));

                      const newItem = deleteItemById({ root, layerName: 'meta', targetId: deleteGoalId });

                      startRelacionamento(JSON.stringify(newItem));
                      atualizarRelacionamento();

                      DeleteGoasElaborations(deleteGoalId);
                      setDeleteGoalId(0)
                    }

                    setOpenDeleteModal3(false);
                  }} />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
        {objetivos.length > 0 && (
          <Grid item xs={12}>
            <div className="add_line_wrapper">
              <p onClick={() => appendGoals(defaultValue)}>
                {`+ Adicionar meta`}
              </p>
            </div>
          </Grid>
        )}
      </>
    );
  };

  const ReplaceButton = () => {
    if (tipoFluxo != 'substituir') return null;
    return (
      <Grid item xs={4}>
        <button className="recicle_content_button" type='button' onClick={() => {
          if (data.length > 0) {
            setReutilizar(true);
          } else {
            setOpenDisclaimer(true);
          }
        }}>
          <p>Reutilizar conteúdo</p>
        </button>
      </Grid>
    );
  };

  if (loading) {
    return <LoadingBuffer />
  }

  return (
    <form onSubmit={handleSubmitGoals(onSubmit)}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div style={{ height: '1px', background: '#B4B4B4' }}></div>
          </Grid>
          {ReplaceButton()}
          {ThematicAxisBanner()}
          {Fields()}
          <Grid item xs={12}>
            <div style={{ height: '1px', background: '#B4B4B4' }}></div>
          </Grid>
          <Grid item xs={12}>
            <ActionButtonElaborations disable={disabeSubmit} isOptional="true" layer_indicator={false} isEmpty={eixos_tematicos[currentIndexEixo]?.obejtivos?.length == 0} />
          </Grid>
          <ReutilizarElaborationDialog
            title="Metas"
            reuseData={data}
            open={reutilizar}
            setOpen={() => setReutilizar(false)}
            setValue={(e) => {
              if (e.some((item: any) => item.hasOwnProperty('metas'))) {
                e.forEach((item: any) => {
                  setValueGoals('meta', transformMetaDataReuse(item.metas))
                })
              } else {
                setValueGoals('meta', transformMetaDataReuse(e))
              }
            }}
          />
          <DisclaimerReuseElaborationDialog open={openDisclaimer} setOpen={setOpenDisclaimer} />
          <CreateUnityElaboration onClose={() => setOpenUnity(false)} open={openUnity} save={(e) => handleSaveUnity(e)} />
        </Grid>
      </Container>
    </form>
  )
}
